import { isMultiticketV1Shown } from '../../experimentation';
import type { checkoutDisqualifications } from '../../types';

export const shouldShowMultiTicketsSelection = (
    checkoutDisqualifications: checkoutDisqualifications,
) => {
    const isMultiticketExperimentActive = isMultiticketV1Shown();
    const hasMoreThanOneTicket = checkoutDisqualifications.more_than_one_ticket;
    const disqualificationKeys: Array<keyof checkoutDisqualifications> = [
        'discount_code',
        'has_addons',
        'has_discounts',
        'has_donations',
        'has_inventory_tiers',
        'has_waiting_room',
        'has_waitlist',
        'is_canceled',
        'is_postponed',
        'is_rsvp',
        'is_sales_ended',
        'repeating_event',
        'reserved_seating',
        'sold_out',
    ];

    return (
        isMultiticketExperimentActive &&
        hasMoreThanOneTicket &&
        disqualificationKeys.every((key) => !checkoutDisqualifications[key])
    );
};
